declare global {
    interface Window {
        adobeDataLayer: unknown[];
    }
}

export const clickTracking = (name: string, position: string) => {
    if (!window) {
        return;
    }

    if (!window.adobeDataLayer || !window.adobeDataLayer.push) {
        window.adobeDataLayer = [];
    }

    window.adobeDataLayer.push({
        event: 'ctaClick',
        linkDetails: {
            name: name.toLowerCase(),
            position
        },
    });
};
